// ----------------------------------------------------------------------------
// Component: Image Panel
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------


// Styles
import './_image-panel.scss';

// -------------------------------------
// Variables
// -------------------------------------
const SECTION_SELECTOR = '.image-panel__container';
const BIG_TITLE_WRAPPER = '.big-title__wrapper';
const BIG_TITLE_TEXT = '.big-title';
const LITTLE_TITLE_WRAPPER = '.little-title__wrapper';
const LITTLE_TITLE_TEXT = '.little-title';
let resizeTimer;


function getTextWidth(textElement) {
    const textRect = textElement.getBoundingClientRect();
    return textRect.width;
}


function adjustFontSize(textElement, containerElement, mobileMedia) {
    const containerWidth = containerElement.offsetWidth;
    const textWidth = getTextWidth(textElement);

    if ( mobileMedia.matches && textWidth < containerWidth ) {
        const ratio = containerWidth / textWidth * 0.93;
        const newFontSize = parseFloat(window.getComputedStyle(textElement).fontSize) * ratio;
        textElement.style.fontSize = newFontSize + 'px';
    } else if ( textWidth > containerWidth ) {
        const ratio = containerWidth / textWidth * 1.01;
        const newFontSize = parseFloat(window.getComputedStyle(textElement).fontSize) * ratio;
        textElement.style.fontSize = newFontSize + 'px';
    } else {
        // Reset font size if text fits within the container
        textElement.style.fontSize = ''; // Reset to default or any other desired size
        containerElement.style.marginTop = '';
    }
}

function handleResponsiveText(mobileMedia) {
    document.querySelectorAll(SECTION_SELECTOR)?.forEach((element) => {
        const bigText = element.querySelector(BIG_TITLE_TEXT);
        const bigTextContainer = element.querySelector(BIG_TITLE_WRAPPER);
        const littleText = element.querySelector(LITTLE_TITLE_TEXT);
        const littleTextContainer = element.querySelector(LITTLE_TITLE_WRAPPER);

        // Check if bigText and bigTextContainer are not null
        if (bigText && bigTextContainer) {
            adjustFontSize(bigText, bigTextContainer, mobileMedia);
        }

        // Check if littleText and littleTextContainer are not null
        if (littleText && littleTextContainer) {
            adjustFontSize(littleText, littleTextContainer, mobileMedia);
        }
    });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    const mobileMedia = window.matchMedia('(max-width: 679px)');

    handleResponsiveText(mobileMedia);
});

window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        const mobileMedia = window.matchMedia('(max-width: 679px)');

        handleResponsiveText(mobileMedia);
    }, 200);
});